declare global {
  interface Window {
    changeSFXVolume: () => void;
    changeTestimonyVolume: () => void;
    changeShoutVolume: () => void;
  }
}

/**
 * Unified SFX volume (matches the AO2 client): a single slider drives the
 * sfx, shout and testimony/guilty audio elements -- previously each had
 * its own native <audio controls> volume, which was inconsistent with the
 * music/blip sliders. Frame SFX also read client_sfxaudio.volume, so they
 * follow this slider too.
 */
const SFX_AUDIO_IDS = [
  "client_sfxaudio",
  "client_shoutaudio",
  "client_testimonyaudio",
];

export function changeSFXVolume(): void {
  const slider = document.getElementById("client_svolume") as HTMLInputElement | null;
  const vol = slider ? Number(slider.value) : 1;
  for (const id of SFX_AUDIO_IDS) {
    const el = document.getElementById(id) as HTMLAudioElement | null;
    if (el) el.volume = vol;
  }
  try {
    localStorage.setItem("sfxVolume", String(vol));
  } catch (e) { /* private mode */ }
}
window.changeSFXVolume = changeSFXVolume;

// Kept for any existing callers; both now route through the unified slider.
export function changeShoutVolume(): void {
  changeSFXVolume();
}
export function changeTestimonyVolume(): void {
  changeSFXVolume();
}
window.changeShoutVolume = changeShoutVolume;
window.changeTestimonyVolume = changeTestimonyVolume;
